window.VegasCatalog.Order = {
	make: function ($form, callback) {
		let route = $form.attr('action');
		let params = $form.serializeArray();

		$.post(route, params, function (data) {
			if (callback) {
				callback(data);
			}
		})
	},
};

$(document).ready(function () {
	$(document).on('change', '#form-cart [name=delivery_id]', function () {
		let id = $(this).attr('id'),
			val = parseInt($(this).val()),
			$containerOrder = $(this).closest('.catalog-cart-form'),
			$currentDelivery = $(this).closest('.form-check'),
			$allDeliveries = $containerOrder.find('.form-check');

		// use required
		$allDeliveries.find('.toggle-required').removeAttr('required');
		$allDeliveries.find('input[type=text], select').attr('disabled', 'disabled');

		$currentDelivery.find('.toggle-required').attr('required', 'required');
		$currentDelivery.find('input[type=text], select').removeAttr('disabled');

		VegasCatalog.Cart.updateTotalAll();
	});

	$(document).on('submit', '#form-cart', function () {
		$('.catalog-cart--preload').addClass('show');
		let $form = $(this);

		VegasCatalog.Order.make($form, function (data) {
			if (data.error) {
				$('.catalog-cart--preload').removeClass('show')
				alert(data.msg);
			} else {
				location.href = data.redirect_to;
			}
		});

		return false;
	});

	// Способы доставки и оплаты
	$(document).on('change', '.radio-area input[type=radio]', function () {
		let $self = $(this),
			$container = $self.closest('.radio-area'),
			$showTitle= $container.find('[data-method-title]'),
			title = $self.data('title');

		if (title.indexOf('%') === -1) {
			$showTitle.text(title);
		}

		return false;
	});

	$(document).on('keydown', '#form-cart #user_address', function () {
		let val = $(this).val();
		let $formCheck = $(this).closest('.form-check');
		let $radio = $formCheck.find('input[type=radio]');
		let $deliveryArea = $formCheck.closest('.delivery-area');
		let $showTitle = $deliveryArea.find('[data-method-title]');
		$showTitle.text($radio.data('title').replace('%address%', val));
	});

	$(document).on('keydown', '#form-cart', function (event) {
		return event.key != "Enter";
	});
});